// @flow
import React, { PureComponent } from 'react';
import CardClub from 'containers/fragments/card/CardClubContainer';
import ButtonIcon from 'components/fragments/button/ButtonIcon';

import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import { connectHits, Configure, InstantSearch } from 'react-instantsearch-dom';
import { MEILISEARCH_KEY, MEILISEARCH_URL } from 'constants/api';
import type { ClubType } from 'types/Club';

type Props = {
  club: ClubType,
};

type State = {
  page: number,
};

const CLUBS_NEARBY_M = '60000';
const CLUBS_NEARBY_NB = 12;

const searchClient = instantMeiliSearch(MEILISEARCH_URL, MEILISEARCH_KEY, { paginationTotalHits: 5000 });
class ClubNearby extends PureComponent<Props, State> {
  state: State = {
    page: 0
  };

  _setPage = (page: number) => (e: MouseEvent) => {
    e.preventDefault();
    this.setState({ page });
  };

  render() {
    const { 
      club, 
    } = this.props;

    if (!club || !club.lat || !club.long || (club.lat === 0 && club.long === 0)) {
      return null;
    }

    let filters = '_geoRadius('+club.lat+', '+club.long+', '+CLUBS_NEARBY_M+') AND nom != "'+club.name+'"';
    let sort = '_geoPoint('+club.lat+', '+club.long+'):asc';

    const Clubs = connectHits(({ hits, clubLatitude, clubLongitude, page }) => {
      const maxPage = Math.max(Math.ceil(hits.length / 3) - 1, 0);
      return (
        <>
          <div className="carousel__nav">
            <ButtonIcon
              label={null}
              url={null}
              icon="icon-arrow-left"
              isDisabled={page === 0}
              onClick={this._setPage(page - 1)}
              titleSEO="Précédent" />
            <ButtonIcon
              label={null}
              url={null}
              icon="icon-arrow-right"
              isDisabled={page === maxPage}
              onClick={this._setPage(page + 1)}
              titleSEO="Suivant" />
          </div>
          <div className="carousel__wrapper">
              {hits.sort(function (a, b) {
                      return a._geoDistance - b._geoDistance;
                  }).slice(page * 3, 4 + page * 3).map((club, index) => (
                  <CardClub
                      key={club.identifiant}
                      club={{
                        id: club.id || 'club',
                        img: 'https://api-agregateur-static.ffr.fr/assets' + club.embleme,
                        name: club.nom,
                        searchName: '',
                        long: club._geoloc.lng,
                        lat: club._geoloc.lat,
                        competitions: [],
                        practices: [],
                        adress: {
                          complement: '',
                          street: '',
                          postalCode: '',
                          locality: ''
                        },
                        slug: club.identifiant}}
                      distance={
                          (!!club._geoloc.lat || !!club._geoloc.lng)
                              ? club._geoDistance / 1000
                              : 0
                      }
                  />
              )
              )}
            </div>
          </>
      );
    });

    return (
      <InstantSearch indexName={'Clubs:'+sort} searchClient={searchClient}>
        <Configure query={''} distinct hitsPerPage={CLUBS_NEARBY_NB} filters={filters} />
        <div className="col">
          <div className="box block-carousel mb-6 mb-md-7 mb-lg-8 mt-lg-4">
            <h3 className="mb-3 ft-400">Clubs aux alentours</h3>
            <div className="carousel">
              <Clubs
                  clubLatitude={club.lat}
                  clubLongitude={club.long}
                  page={this.state.page}
                />
            </div>
          </div>
        </div>
      </InstantSearch>
    );
  }

}

export default ClubNearby;
